import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useLayoutEffect, useState } from 'react';
import { TABLES } from '../../../../Apis/Tables';
import { clearSearchFilters } from '../../../../reduxToolkit/Search/SearchSlice';
import { GetListSearchModels } from '../../../../reduxToolkit/Search/SearchApi';
import { MODELS } from '../../../../Apis/Models';
import { permissionObj } from '../../../../Helpers/permission';
import { useNavigate } from 'react-router-dom';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const LogsApp = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const dispatch = useDispatch();
    const { getListSearchModels } = useSelector((state) => state.SearchSlice);
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [modelType, setModelType] = useState('');
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [modified, setModified] = useState(false);
    const [moduleId, setModuleId] = useState();
    const [option, setOption] = useState(`${TABLES.USER_ACCESS_LOG}`);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    //Set the available steps based on permissions and environment.
    useLayoutEffect(() => {
        let steps = [];
        if (DEV || permission?.includes(permissionObj?.WEB_LOG_ACTION_READ)) steps.push(t('actions'));
        if (DEV || permission?.includes(permissionObj?.WEB_LOG_PLATFORM_READ)) steps.push(t('platform_access'));

        if (permission?.includes(permissionObj?.WEB_LOG_ACTION_READ)) {
            setActiveStep(0);
        } else if (permission?.includes(permissionObj?.WEB_LOG_PLATFORM_READ)) {
            setActiveStep(1);
        }

        setSteps(steps);
    }, [permission, i18n.language]);

    // useEffect to avoid first load
    useEffect(() => {
        return () => {
            dispatch(clearSearchFilters());
        };
    }, [activeStep]);
    //Update model and option based on the currently active step.
    useEffect(() => {
        setModelType('');
        if (activeStep === 0) {
            setModuleId(`${MODELS.LogModule}`);
            setOption(`${TABLES.LOG_MODULE}`);
        } else if (activeStep === 1) {
            setModuleId(`${MODELS.LogInLog}`);
            setOption(`${TABLES.LOG_IN_LOG}`);
        }
    }, [activeStep]);

    // check permission check
    useEffect(() => {
        dispatch(GetListSearchModels());
    }, []);
    //Handle step change in the UI
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    return {
        t,
        steps,
        activeStep,
        setActiveStep,
        modified,
        setModified,
        moduleId,
        option,
        modelType,
        setModelType,
        finalArray,
        setFinalArray,
        filterDialogShow,
        setFilterDialogShow,
        getListSearchModels,
        handleStepChange,
        DEV,
        permission,
        navigate,
        searchElement,
        setSearchElement,
        search,
        setSearch
    };
};

export default LogsApp;
